import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { TabButtonContainer } from './component.styles'

function TabButtonOutlined({ label, onClick, onKeyPress, wide }) {
  // the stroke on line 36 is set to a hex value because
  // the svg doesn't render properly if its set to currentColor
  return (
    <Fragment key={`tab-button-outlined-${label}`}>
      <TabButtonContainer
        aria-label={label}
        dataTestId="k8-admin-dashboard-tab-button"
        onClick={onClick}
        onKeyPress={onKeyPress}
        role="tab"
        tabIndex={0}
      />
      {wide && (
        <svg
          enableBackground="new 0 0 226 35"
          height="35"
          id="tab-button-outlined-wide"
          version="1.1"
          viewBox="0 0 226 35"
          width="226"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="currentColor"
            fillRule="evenodd"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              d="M38.2689118,0.999999998 L187.991089,1.00983112 C194.248778,1.06559322 199.273507,2.55186945 203.040681,5.52832868 C206.797216,8.49638106 209.28119,12.9340034 210.544201,18.8048821 C211.925272,25.2245376 215.050983,30.0250112 219.885643,33.2319731 C221.570093,34.3493146 223.46656,35.2729235 225.576053,36 L197.999942,36 L27.0002468,36.0098708 L0.683123036,36.0033766 C2.79654359,35.2757837 4.69627604,34.3510449 6.38333447,33.2319731 C11.2179943,30.0250112 14.3437057,25.2245376 15.7247764,18.8048821 C16.8957686,13.3617381 19.1155038,9.15093664 22.4270671,6.1997592 C25.7336688,3.25300347 30.1159603,1.57571211 35.5529789,1.12339463 C36.0719642,1.04554247 36.5318111,1.00987082 37.0009516,1.00987036 L37.7222669,1.00918393 C37.9066313,1.00483334 38.0922943,1.00175585 38.2689118,0.999999998 Z"
              id="Combined-Shape"
              stroke="#EEF0F2"
              strokeWidth="2"
            />
          </g>
          <text dominantBaseline="middle" textAnchor="middle" x="50%" y="53%">
            {label}
          </text>
        </svg>
      )}
      {!wide && (
        <svg
          enableBackground="new 0 0 159 41"
          height="41"
          id="tab-button-outlined"
          version="1.1"
          viewBox="0 0 159 41"
          width="159"
          xmlSpace="preserve"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7 38c2.1-.7 4-1.7 5.7-2.8 4.8-3.2 8-8 9.3-14.4 1.3-5.9 3.7-10.3 7.5-13.3S46 3 52.2 3h55.3c.8 0 1.2 0 1.5.1 5.7.4 10.2 2 13.6 5 3.4 3 5.7 7.2 6.9 12.8 1.4 6.4 4.5 11.2 9.3 14.4 1.7 1.1 3.6 2 5.7 2.8"
            fill="currentColor"
            stroke="currentColor"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M52.2 3h55.3c.8 0 1.2 0 1.5.1 5.7.4 10.2 2 13.6 5 3.4 3 5.7 7.2 6.9 12.8 1.4 6.4 4.5 11.2 9.3 14.4 1.7 1.1 3.6 2 5.7 2.8H14.7c2.1-.7 4-1.7 5.7-2.8 4.8-3.2 8-8 9.3-14.4C31 15 33.4 10.6 37.2 7.6S46 3.1 52.2 3z"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
          <text dominantBaseline="middle" textAnchor="middle" x="50%" y="53%">
            {label}
          </text>
        </svg>
      )}
    </Fragment>
  )
}

TabButtonOutlined.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  wide: PropTypes.bool,
}

export default TabButtonOutlined
